import Dexie, { type EntityTable } from 'dexie'
import type { ChecklistStatus } from '@ck/domain'

export interface PendingOperation {
  operationId: string
  itemId: string
  expectedVersion: number
  status: ChecklistStatus
  note?: string
  capturedAt: string
  createdAt: string
}

class ChecklistDatabase extends Dexie {
  operations!: EntityTable<PendingOperation, 'operationId'>
  constructor() {
    super('ck-checklist')
    this.version(1).stores({ operations: '&operationId, itemId, createdAt' })
  }
}

export const checklistDb = new ChecklistDatabase()

// Mantém no máximo uma operação pendente por item: se o mecânico mudar de ideia (ex.: toca
// OK, depois corrige para Reprovado) antes de sincronizar, a nova intenção substitui a
// anterior em vez de empilhar. Sem isso, cada toque no mesmo item vira uma operação nova
// com o mesmo `expectedVersion` — a sincronização aplica só a primeira (que já incrementa a
// versão no servidor) e todas as seguintes ficam em conflito de versão para sempre, travando
// "Concluir etapa" com pendências que nunca somem.
export async function enqueueOperation(operation: Omit<PendingOperation, 'operationId' | 'createdAt'>): Promise<void> {
  const existing = await checklistDb.operations.where('itemId').equals(operation.itemId).first()
  await checklistDb.operations.put({
    ...operation,
    operationId: existing?.operationId ?? crypto.randomUUID(),
    createdAt: existing?.createdAt ?? new Date().toISOString()
  })
}

